var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import { Button } from "syf-component-library/ui/atoms";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import Modal, { CancelButton, FooterWrapper, Icon } from "./subcomponents";
import modalIds from "../../../const/modalIds";
import { useVantageContext } from "../../../context/vantageContext";
var CrossBorderModal = function () {
    var _a = useVantageContext(), _b = _a.state.crossBorderModal, isOpenedFromModal = _b.isOpenedFromModal, isOpen = _b.isOpen, crossBorderUrl = _b.crossBorderUrl, dispatch = _a.dispatch, restoreFocus = _a.restoreFocus;
    var t = useTranslation().t;
    var closeModal = function () {
        dispatch({
            reopenQuestionsModal: isOpenedFromModal,
            crossBorderModal: {
                isOpen: false,
                isOpenedFromModal: false,
                crossBorderUrl: "",
            },
        });
        restoreFocus();
    };
    return (_jsx(Modal, __assign({ id: "cross-border", title: "Cross Border Modal", containerId: modalIds.CROSS_BORDER_MODAL_ID, isOpen: isOpen, escapeModalHandler: closeModal, "data-cy-include": true, footerButtons: [
            _jsxs(FooterWrapper, { children: [_jsx(CancelButton, __assign({ buttonType: "secondary", onClick: closeModal }, { children: t("actions.cancel") })), _jsx(Button, __assign({ buttonType: "primary", onClick: function () {
                            window.open(crossBorderUrl, "_blank");
                            closeModal();
                        } }, { children: t("actions.openTab") }))] }, "cross-border-footer"),
        ] }, { children: _jsxs(Inset, __assign({ top: "xxlarge", left: "xxlarge", right: "xxlarge", bottom: "medium" }, { children: [_jsx(Icon, { color: "#34657F", size: "2x", icon: faTriangleExclamation }), _jsx(Stack, { size: "large" }), _jsx(Body, { children: t("crossBorderText") })] })) })));
};
export default CrossBorderModal;
